export default "__VITE_ASSET__5tP1DNnZ__"